import ThankYou from './ThankYou';

export default ThankYou;



// WEBPACK FOOTER //
// ./src/components/shared/ThankYou/index.js